export default {
  name: 'Timeline',
  path: '/projects/:projectId/timeline',
  meta: {
    title: 'router.timeline'
  }
};
